import axios from "axios";
import React, {useContext, useEffect, useRef, useState} from "react";
import Button from "../../Button/Button";
import Checkbox from "../../FormComponents/Checkbox/Checkbox";
import Dropdown from "../../FormComponents/Dropdown/Dropdown";
import Input from "../../FormComponents/Input/Input";
import {KoerberSendEmailMandatory} from "../SendEmailMandatory/SendEmailMandatory.style";
import {sizes} from "../../../utils/styled/_variables.styled";
import {useIsMobile} from "../../../utils/styled/_mixins.style";
import {StateContext} from "../../../context/stateContext";
import {WidgetInstance} from "friendly-challenge";

const DownloadForm = React.forwardRef((props, ref) => {
  const {
      marketingConsentText,
      countryList,
      USStateList,
      CAStateList,
      LoadingWatcher,
      ThankYouWatcher,
      buttonText,
      category,
      actionPath,
      showCheckbox,
      useAnalytics,
      firstNameText,
      lastNameText,
      emailText,
      companyText,
      countryText,
      stateText,
      requiredFirstNameText,
      requiredLastNameText,
      requiredEmailText,
      requiredCompanyText,
      requiredCountry,
      requiredState,
      countryValues,
      usaStateValues,
      canadaStateValues,
      captchaConfig,
      pageLanguage
  } = props;

  const { isMobile } = useIsMobile(sizes.tabletLarge);
  const { triggerFocusOnStickyForm } = useContext(StateContext);


  const [autoFill, setAutoFill] = useState(false);
  
  const [firstName, setFirstName] = useState("");
  const [invalidateFirstName, setInvalidateFirstName] = useState(false);
  const [lastName, setLastName] = useState("");
  const [invalidateLastName, setInvalidateLastName] = useState(false);
  const [email, setEmail] = useState("");
  const [invalidateEmail, setInvalidateEmail] = useState(false);
  const [company, setCompany] = useState("");
  const [invalidateCompany, setInvalidateCompany] = useState(false);
  const [country, setCountry] = useState("");
  const [invalidateCountry, setInvalidateCountry] = useState(false);
  const [state, setState] = useState('');
  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));
  const [allowSubmit, setAllowSubmit] = useState(true);

  const widgetRef = useRef(null);

  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const companyRef = useRef(null);


    useEffect(() => {
        if(widgetRef?.current){

            const options = {

                doneCallback: solution => {
                    let form = ref.current;
                    let button = form.querySelector('button');
                    button.removeAttribute("disabled")
                    button.classList.remove("disabled");
                },
                language: pageLanguage,
                ...captchaConfig
            }
            const widget = new WidgetInstance(widgetRef.current, options);
        }
    }, [captchaConfig, pageLanguage]);


  useEffect(() => {
      if(searchParams.get('submit') && !!sessionStorage.getItem("firstName")) {
          setAutoFill(true);
          if(!!ThankYouWatcher) ThankYouWatcher(true);
      }
      
      if(searchParams.get('uTMCampaign') != null) {
          localStorage.setItem("uTMCampaign", searchParams.get('uTMCampaign'))
      }
      if(searchParams.get('uTMContent') != null) {
          localStorage.setItem("uTMContent", searchParams.get('uTMContent'))
      }
      if(searchParams.get('uTMMedium') != null) {
          localStorage.setItem("uTMMedium", searchParams.get('uTMMedium'))
      }
      if(searchParams.get('uTMSource') != null) {
          localStorage.setItem("uTMSource", searchParams.get('uTMSource'))
      }

  }, [window.location.search]);
  
  useEffect(() => {
      if(country === "United States") {
          setState(USStateList[0].label.split(',')[0].replace(/[^a-zA-Z0-9]/g, '-').toLowerCase())
      } else if(country === "Canada") {
          setState(CAStateList[0].label.split(',')[0].replace(/[^a-zA-Z0-9]/g, '-').toLowerCase())
      }
  }, [country]);

  const handleConsentCheckbox = (event) => {
      setConsentCheckbox(event.target.checked);
  };

  const errorHandler = (event) => {
      return !event.currentTarget.value
  }

  const errorHandlerEmail = (event) => {
    return validateEmail(event.currentTarget.value);
  }

  const validateEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return email ? !regex.test(email) : true;
  }

  const validateRequired = () => {
      if(firstName && lastName && email && company && country && !document.querySelector('input.nt').value) {
          handleSubmit();
      } else {
          setInvalidateFirstName(!firstName);
          setInvalidateLastName(!lastName);
          setInvalidateEmail(validateEmail(email));
          setInvalidateCompany(!company);
          setInvalidateCountry(!country);

          requestFocusToInputWithError();
      }
  }

  React.useImperativeHandle(ref, () => ({
    validateRequired
  }));

  const handleSubmit = () => {
    if(!!LoadingWatcher) LoadingWatcher(true);
      let data = JSON.stringify({
                  "firstName": firstName,
                  "lastName": lastName,
                  "email": email,
                  "company": company,
                  "country": country,
                  "privacyCheckbox": true,
                  "consentCheckbox": consentCheckbox,
                  "state": state,
                  "uTMCampaign": localStorage.getItem("uTMCampaign") != null ? localStorage.getItem("uTMCampaign") : "",
                  "uTMContent": localStorage.getItem("uTMContent") != null ? localStorage.getItem("uTMContent") : "",
                  "uTMMedium": localStorage.getItem("uTMMedium") != null ? localStorage.getItem("uTMMedium") : "",
                  "uTMSource": localStorage.getItem("uTMSource") != null ? localStorage.getItem("uTMSource") : "",
                  // "nice_try": document.querySelector('input.nt').value,
                  "lastformsource": category ? category : ""
      });
      
      let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/bin/marketo',
            headers: { 
            'Content-Type': 'application/json', 
            'Cookie': 'cq-authoring-mode=TOUCH'
          },
          data : data
      };

      axios.request(config)
          .then((response) => {
              const params = !!searchParams.toString() ? `&${searchParams.toString()}` : "";
              window.location.href = `${actionPath}?submit=success` + params;
              // edit here to put thankyou page
          })
          .catch((error) => {
              console.error(error);
              if(!!LoadingWatcher) LoadingWatcher(false);
      });
  }   

  const requestFocusToInputWithError = () => {
    if(!firstName){
        firstNameRef.current.focus();
    } else if(!lastName){
        lastNameRef.current.focus();
    } else if(!email){
        emailRef.current.focus();
    } else if(!company){
        companyRef.current.focus();
    }
  }

  useEffect(() => {
    if(triggerFocusOnStickyForm === 0) return;
    firstNameRef.current.focus();
  }, [triggerFocusOnStickyForm]);

  return (
      <KoerberSendEmailMandatory
          ref={ref}
          onSubmit={(event) => handleSubmit(event)}
          data-analytics="form__download"
      >
          <div className="mandatory-form">
              <Input
                  noIcon
                  name={"firstName"}
                  labelText={firstNameText ? firstNameText : "First Name"}
                  errorMessage={requiredFirstNameText ? requiredFirstNameText : "Enter a first name."}
                  validate={setFirstName}
                  required
                  invalid={invalidateFirstName}
                  errorHandler={errorHandler}
                  inputRef={firstNameRef}
              />
              <Input
                  noIcon
                  name={"lastName"}
                  labelText={lastNameText ? lastNameText : "Last Name"}
                  errorMessage={requiredLastNameText ? requiredLastNameText : "Enter a last name."}
                  validate={setLastName}
                  required
                  invalid={invalidateLastName}
                  errorHandler={errorHandler}
                  inputRef={lastNameRef}
              />
              <Input
                  noIcon
                  name={"email"}
                  labelText={emailText ? emailText : "E-Mail"}
                  errorMessage={requiredEmailText ? requiredEmailText : "Enter a valid e-mail."}
                  validate={setEmail}
                  required
                  invalid={invalidateEmail}
                  errorHandler={errorHandlerEmail}
                  inputRef={emailRef}
              />
              <Input
                  noIcon
                  name={"company"}
                  labelText={companyText ? companyText : "Company"}
                  errorMessage={requiredCompanyText ? requiredCompanyText : "Enter a company name."}
                  validate={setCompany}
                  required
                  invalid={invalidateCompany}
                  errorHandler={errorHandler}
                  inputRef={companyRef}
              />
              <Input
                  noIcon
                  className={"nt"}
                  value={""}
                  name={"pronoum"}
                  labelText={"Pronoum"}
              />
              <Dropdown
                  labelText={countryText ? countryText : "Country"}
                  required
                  useLabelAsValue={true}
                  name={"country"}
                  errorMessage={requiredCountry ? requiredCountry : "Select a country."}
                  validate={setCountry}
                  options={countryValues?.length > 0 ? countryValues : countryList}
                  invalid={invalidateCountry}
              />
              {(country === "United States" || country === "Canada") && (
                  <Dropdown
                      labelText={stateText ? stateText : "State"}
                      validate={setState}
                      useLabelAsValue={true}
                      required
                      name={"state"}
                      options={country === "United States" ?
                          (usaStateValues && usaStateValues.length ? usaStateValues : USStateList)
                          :
                          (canadaStateValues && canadaStateValues.length ? canadaStateValues : CAStateList)}
                  />
              )}
              {showCheckbox && <Checkbox
                  name={"consentCheckbox"}
                  onChange={handleConsentCheckbox}
                  labelText={marketingConsentText || 'I want to receive marketing information from Körber Supply Chain.'}
              />}
          </div>
          <div className="form__captcha" ref={widgetRef}></div>
          {isMobile && <Button
              text={buttonText}
              noIcon
              onClick={() => validateRequired()}
          />}
      </KoerberSendEmailMandatory>
  );
});

export default DownloadForm;
